import { render, staticRenderFns } from "./CompaniesListTable.vue?vue&type=template&id=45ec089e&"
import script from "./CompaniesListTable.vue?vue&type=script&lang=js&"
export * from "./CompaniesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports